/**
 * Os periodos que o painel oferece.
 *
 * O VOCABULARIO e o do `components/period`; o que mora aqui e quais desses atalhos
 * ESTA tela oferece e o codigo de cada um no endereco.
 *
 * ## O que mudou, e por que
 *
 * O painel oferecia tres janelas - Dia, Semana e Mes - ancoradas numa data de
 * referencia. Era pouco: nao havia como perguntar "como foi o trimestre" nem "como
 * foi de 1 a 15 de setembro", e a pergunta "como foi a semana retrasada" so se
 * respondia mexendo na ancora e contando nos dedos.
 *
 * Os tres continuam existindo como intervalo - um dia, sete dias, trinta dias -, e
 * agora ao lado de outros quatro e da escolha livre de datas.
 */
export const DASHBOARD_PERIODS = ['1d', '7d', '30d', '90d', 'month', 'last-month', 'year', 'custom'];
/**
 * O codigo de cada periodo no endereco.
 *
 * Os digitos `0`, `1` e `2` eram WEEK, MONTH e DAY, e os tres continuam querendo
 * dizer o mesmo intervalo que queriam: sete dias, trinta dias e um dia. Endereco
 * antigo abre onde sempre abriu; o que mudou foi o que existe ALEM deles.
 */
export const DASHBOARD_PERIOD_CODES = {
    '0': '7d',
    '1': '30d',
    '2': '1d',
    '3': '90d',
    '4': 'month',
    '5': 'last-month',
    '6': 'year',
    '7': 'custom'
};
/** Os atalhos do painel, na ordem em que aparecem no seletor. */
export const DASHBOARD_SHORTCUTS = DASHBOARD_PERIODS;
//# sourceMappingURL=dashboard.periods.js.map